import { Checkbox, CheckboxProps as MaterialCheckboxProps, FormControlLabel } from "@mui/material"
import { motion } from "framer-motion"
import React from "react"
import styled, { ThemeProvider } from "styled-components"
import { theme } from "../../../theme"
import { CommonPopperProps } from "./CommonPopperProps"
import { Popper } from "./Popper"
import { PopperSaveButton } from "./PopperSaveButton"
import { PopperDarkTheme, PopperLightTheme } from "./popperThemes"

export type CheckboxProps = Omit<MaterialCheckboxProps, "name" | "onChange" | "checked"> & {
  onChange: (value: any) => void
  checked: boolean
  label: string
}

export type CheckListPopperProps = CommonPopperProps & {
  fieldName?: string
  onSubmit: () => void
  checkBoxOptions: CheckboxProps[]
}

export const CheckListPopper = (props: CheckListPopperProps) => {
  const {
    popperTitle,
    fieldName,
    onClose,
    onDelete,
    onSubmit,
    checkBoxOptions,
    className,
    lightMode,
    anchorEl,
    anchorOrigin,
    transformOrigin,
    confirmText,
  } = props

  return (
    <ThemeProvider theme={lightMode ? PopperLightTheme : PopperDarkTheme}>
      <Popper
        title={popperTitle}
        onClose={onClose}
        onDelete={onDelete}
        anchorEl={anchorEl}
        className={className}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {checkBoxOptions.map((option) => (
          <CustomFormControlLabel
            key={option.label}
            label={option.label}
            control={<Checkbox name={fieldName} onChange={option.onChange} checked={option.checked} />}
          />
        ))}
        <PopperSaveButton onClick={onSubmit}>{confirmText}</PopperSaveButton>
      </Popper>
    </ThemeProvider>
  )
}

const CustomFormControlLabel = styled(motion(FormControlLabel))`
  width: 100%;
  padding: 9px 0;
  align-items: end;

  .MuiButtonBase-root {
    margin: 0 11px 0 9px;
    padding: 0;
    color: ${theme.color.grey2};
  }
  .MuiButtonBase-root.Mui-checked {
    color: ${theme.color.primary};
  }
`
